import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import type { PaymentCardParams } from '@src/domains/payments';
import type { Transactable } from '@src/domains/transactables';
import {
  clearPaymentErrors,
  getPaymentStatus,
  paymentErrorsSelector,
  paymentOngoingSelector,
  processPayment,
} from '@src/features/payments/store/payment';

export const useProcessPayment = (transactable: Transactable) => {
  const dispatch = useAppDispatch();

  const submitting = useAppSelector(paymentOngoingSelector);
  const errors = useAppSelector(paymentErrorsSelector);

  const pay = useCallback(
    (paymentMethodId: string, paymentCard?: PaymentCardParams) =>
      dispatch(processPayment({ ...transactable, paymentMethodId, paymentCard })),
    [dispatch, transactable],
  );

  const clear = useCallback(() => dispatch(clearPaymentErrors()), [dispatch]);

  const syncStatus = useCallback(() => dispatch(getPaymentStatus(transactable)), [dispatch, transactable]);

  return { pay, submitting, errors, clearErrors: clear, syncStatus };
};

export default useProcessPayment;
